import React from 'react';
import { motion } from 'framer-motion';

// Import your brand logos
import barnettLogo from '../images/barnett.jpg';
import vollamondLogo from '../images/vollamond.jpg';

const BrandsUpdated = () => {
  // Only 2 brands, no duplicates
  const brands = [
    { id: 1, name: 'Barnett', image: barnettLogo },
    { id: 2, name: 'Vollamond', image: vollamondLogo },
  ];

  return (
    <section id="brands" className="py-20">
      <div className="container mx-auto px-4 md:px-6">
        {/* Title pill */}
        <div className="flex justify-center mb-10">
          <motion.div
            className="inline-flex items-center gap-2 rounded-full bg-gray-900 px-6 py-2 shadow-lg"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
          >
            <span className="h-2.5 w-2.5 rounded-full bg-yellow-400" />
            <span className="font-playfair font-bold text-lg md:text-xl text-white">
              Our Brands
            </span>
          </motion.div>
        </div>

        {/* Only 2 logos, centered */}
        <motion.div
          className="flex flex-wrap justify-center gap-6 md:gap-10"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          {brands.map((brand) => (
            <div
              key={brand.id}
              className="w-40 h-24 md:w-52 md:h-28 flex items-center justify-center bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <img
                src={brand.image}
                alt={brand.name}
                className="max-w-full max-h-full object-contain"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default BrandsUpdated;
